var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiRrLink = function SvgFiRrLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D2F36",
    clipPath: "url(#fi-rr-link_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.479 12.95-2.447 2.447A3.771 3.771 0 0 1 2.7 10.065l2.447-2.449a.75.75 0 0 0-1.062-1.06L1.64 9.005a5.271 5.271 0 0 0 7.456 7.452l2.447-2.446a.75.75 0 0 0-1.06-1.06zM16.555 1.546A5.23 5.23 0 0 0 12.828 0a5.24 5.24 0 0 0-3.726 1.543L6.652 3.99a.75.75 0 0 0 1.06 1.061l2.449-2.446A3.75 3.75 0 0 1 12.826 1.5a3.77 3.77 0 0 1 2.666 6.437l-2.447 2.447a.75.75 0 0 0 1.062 1.061L16.553 9a5.28 5.28 0 0 0 .002-7.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.815 6.22-4.5 4.5a.75.75 0 1 0 1.06 1.06l4.5-4.5a.75.75 0 0 0-1.06-1.06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fi-rr-link_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.096 0h18v18h-18z"
  })))));
};
export default SvgFiRrLink;